module.exports = __webpack_public_path__ + "img/traveler2.b78e5aca.webp";